'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = require('./constants');

var ActionTypes = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
  tasks: 0
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case ActionTypes.BEGIN_TASK:
      return {
        tasks: state.tasks + 1
      };

    case ActionTypes.END_TASK:
      return {
        tasks: state.tasks - 1
      };

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-nprogress/lib/reducer.js
// module id = 1095
// module chunks = 2